import React from "react";
import { IRouteItem, Loadable } from "@techzyapp/ui-lib";
import { REFERRAL_CONFIG_PATH } from "utils/constants/paths";

const ReferralConfig = Loadable(React.lazy(() => import("./View")));

export const ReferralConfigRoute: IRouteItem = {
  path: REFERRAL_CONFIG_PATH,
  element: React.createElement(ReferralConfig),
  accessKeys: ["Support", "ContentCreator", "Analyst", "SystemUserManager"],
  name: "Referral Config",
  iconName: "Share",
};
